import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3398962e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-4 is-flex is-justify-content-space-between is-align-items-center gap-2" }
const _hoisted_3 = { class: "is-flex is-align-items-center gap-2" }
const _hoisted_4 = { class: "title is-size-4 mb-0" }
const _hoisted_5 = { class: "is-flex is-align-items-center gap-1" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title is-size-5" }, " Definition ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title is-size-5" }, " Sample data ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hydra_operation_button = _resolveComponent("hydra-operation-button")!
  const _component_base_tree = _resolveComponent("base-tree")!
  const _component_hierarchy_tree = _resolveComponent("hierarchy-tree")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_loading_block = _resolveComponent("loading-block")!
  const _component_page_content = _resolveComponent("page-content")!

  return (_openBlock(), _createBlock(_component_page_content, { class: "container-narrow" }, {
    default: _withCtx(() => [
      (_ctx.hierarchy)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.hierarchy.name), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.hierarchy.actions.replace)
                  ? (_openBlock(), _createBlock(_component_hydra_operation_button, {
                      key: 0,
                      operation: _ctx.hierarchy.actions.replace,
                      to: { name: 'HierarchyEdit' },
                      variant: "default",
                      size: "normal",
                      label: _ctx.hierarchy.actions.replace.title
                    }, null, 8, ["operation", "label"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("section", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_base_tree, { "tree-data": _ctx.hierarchyTree }, null, 8, ["tree-data"])
            ]),
            _createElementVNode("section", null, [
              _hoisted_8,
              _createVNode(_component_hierarchy_tree, {
                roots: _ctx.hierarchyRoots,
                "next-level": _ctx.hierarchy.nextInHierarchy,
                "endpoint-url": _ctx.endpointUrl
              }, null, 8, ["roots", "next-level", "endpoint-url"])
            ]),
            _createVNode(_component_router_view)
          ]))
        : (_openBlock(), _createBlock(_component_loading_block, { key: 1 }))
    ]),
    _: 1
  }))
}